import React, { useCallback, useMemo } from "react";
import { TextField } from "@material-ui/core";
import { FieldAttributes, useField, useFormikContext } from "formik";
import InputMask from "react-input-mask";
import "../InputTextOld/index.scss";
import { IFormattedResponse } from "../../../model/parametrizedResponse";
import _ from 'lodash';

interface InputTextMask {
    label?: string;
    mask?: string;
    maskChar?: string;
    toUpperCase?: boolean
    formatChars?: { [key: string]: string };
    alwaysShowMask?: boolean;
    placeholder?: string;
    helperText?: string;
    endAdornment?: React.ReactElement;
    beforeChange?: (value: any) => any;
    onValueChange?: (value: any) => void;
    hidden?: boolean;
    disabled?: boolean;
    errorMessage?: string;
    backEndName?: string;
    setFieldToUpdate?: (fieldToUpdate: any) => void;
    error?: boolean;
    formatResponse?: (obj: any) => IFormattedResponse;
    onChangeListener?: (val: string) => void;
    listenerDependency?: any
}

export const InputTextMaskOld = (props: FieldAttributes<InputTextMask>) => {
    const {beforeChange, onValueChange} = props;
    const {
        name, toUpperCase, mask, maskChar, alwaysShowMask, formatChars, label, helperText,
        placeholder, endAdornment, hidden, disabled, errorMessage,
        backEndName, setFieldToUpdate, error, formatResponse, onChangeListener
    } = props;


    const [field, meta, helpers] = useField({name});

    const {handleBlur} = useFormikContext();

    let fieldValue = field.value || (props?.defaultValue ?? "");

    const validationError = meta.error && meta.touched ? meta.error : "";

    const helperTextMemo = useMemo(() => {
        if (validationError !== '') return validationError;
        if (error) return errorMessage;
        return helperText ?? "";
    }, [validationError, error, errorMessage, helperText]);

    const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        let val = event.target.value;
        let cleanValue = val.toString().replace(new RegExp(/([+()\- ])/gi), "");

        if (toUpperCase) cleanValue = cleanValue.toUpperCase();

        if (beforeChange) {
            cleanValue = beforeChange(cleanValue);
        }
        let formattedValue = formatResponse ? formatResponse(cleanValue) : {
            quotationValue: cleanValue,
            value: cleanValue
        };

        helpers.setValue(formattedValue.quotationValue);
        if (onChangeListener) {
            onChangeListener(formattedValue.quotationValue);
        }
        debounce(formattedValue.value);

        if (onValueChange) {
            onValueChange(cleanValue);
        }
    };

    const debounce = useCallback(
        _.debounce((_searchVal: string) => {
            helpers.setValue(_searchVal);
            if (setFieldToUpdate) {
                setFieldToUpdate({name: backEndName, value: _searchVal});
            }
            onChangeListener?.(_searchVal);
        }, 500),
        [props.listenerDependency]
    );

    return (
        <div className={'input-text'} hidden={hidden}>
            <InputMask
                autoComplete="off"
                id={name}
                mask={mask ? mask : "******************************"}
                maskChar={maskChar ? maskChar : ""}
                alwaysShowMask={alwaysShowMask ? alwaysShowMask : false}
                value={fieldValue}
                formatChars={formatChars || {
                    "9": "[0-9]",
                    "a": "[A-ZА-ЯІa-zа-яі]",
                    "*": "[A-ZА-ЯІa-zа-яі0-9]",
                    "_": "[0-9]"
                }}
                disabled={disabled}
                onChange={handleChange}
                placeholder="+38(0__)___-__-__"
                onBlur={handleBlur}>
                {
                    //@ts-ignore
                    (params: any) => (
                        <TextField {...params}
                                   error={error || validationError !== ''}
                                   fullWidth={true}
                                   helperText={helperTextMemo}
                                   InputLabelProps={{
                                       style: {
                                           textOverflow: 'ellipsis',
                                           whiteSpace: 'nowrap',
                                           overflow: 'hidden',
                                           width: '92%'
                                       },
                                       shrink: Boolean(placeholder) || undefined,
                                       position: "top",
                                   }}
                                   value={fieldValue}
                                   variant="outlined"
                                   label={label}
                                   placeholder={placeholder ? placeholder : ""}
                                   InputProps={{
                                       ...params.InputProps,
                                       shrink: "true",
                                       endAdornment: endAdornment
                                   }}/>)}
            </InputMask>
        </div>
    )
};